module.exports = __webpack_public_path__ + "static/media/ybsfzCard.e82cd65e.png";